const realData = [
    {
        "name": "Fresh Fruits",
        "images": "https://www.jiomart.com/images/category/36/thumb/0-36.png",
        "quantity": "One Unit",
        "id": 71,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Fresh Vegetables",
        "images": "https://www.jiomart.com/images/category/35/thumb/0-35.png",
        "quantity": "One Unit",
        "id": 73,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Herbs & Seasonings",
        "images": "https://www.jiomart.com/images/category/37/thumb/0-37.png",
        "quantity": "One Unit",
        "id": 74,
        "price": 150,
        "type": "fruits"
    },
    {
        "name": "Dairy",
        "images": "https://www.jiomart.com/images/category/117/thumb/dairy-20200522.png",
        "quantity": "One Bunch",
        "id": 75,
        "price": 150,
        "type": "fruits"
    },
    {
        "name": "Toast & Khari",
        "images": "https://www.jiomart.com/images/category/46/thumb/0-46.png",
        "quantity": "One Unit",
        "id": 76,
        "price": 80,
        "type": "fruits"
    },
    {
        "name": "Breads and Buns",
        "images": "https://www.jiomart.com/images/category/240/thumb/breads-and-buns-20200522.png",
        "quantity": "One Unit",
        "id": 78,
        "price": 30,
        "type": "fruits"
    },
    {
        "name": "Bakery Snacks",
        "images": "https://www.jiomart.com/images/category/281/thumb/bakery-snacks-20200712.png",
        "quantity": "One Container",
        "id": 79,
        "price": 200,
        "type": "fruits"
    },
    {
        "name": "Atta, Flours & Sooji",
        "images": "https://www.jiomart.com/images/category/14/thumb/0-14.png",
        "quantity": "One Unit",
        "id": 212,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Dals & Pulses",
        "images": "https://www.jiomart.com/images/category/19/thumb/0-19.png",
        "quantity": "One Unit",
        "id": 214,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Rice & Rice Products",
        "images": "https://www.jiomart.com/images/category/16/thumb/0-16.png",
        "quantity": "One Unit",
        "id": 215,
        "price": 20,
        "type": "fruits"
    },
    {
        "name": "Edible Oils",
        "images": "https://www.jiomart.com/images/category/18/thumb/0-18.png",
        "quantity": "One Unit",
        "id": 217,
        "price": 50,
        "type": "fruits"
    },
    {
        "name": "Dry Fruits",
        "images": "https://www.jiomart.com/images/category/17/thumb/0-17.png",
        "quantity": "One Unit",
        "id": 201,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "turmeric",
        "images": "https://www.jiomart.com/images/category/15/thumb/0-15.png",
        "quantity": "One Unit",
        "id": 203,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Madhur Tea Salt",
        "images": "https://www.jiomart.com/images/category/20/thumb/0-20.png",
        "quantity": "One Unit",
        "id": 204,
        "price": 150,
        "type": "fruits"
    },
    {
        "name": "fortune",
        "images": "https://www.jiomart.com/images/category/72/thumb/soya-products-wheat-other-grains-20200522.png",
        "quantity": "One Bunch",
        "id": 205,
        "price": 150,
        "type": "fruits"
    },
    {
        "name": "Biscuits & Cookies",
        "images": "https://www.jiomart.com/images/category/44/thumb/0-44.png",
        "quantity": "One Unit",
        "id": 206,
        "price": 80,
        "type": "fruits"
    },
    {
        "name": "Breakfast Cereals",
        "images": "https://www.jiomart.com/images/category/188/thumb/breakfast-cereals-20200603.png",
        "quantity": "One Unit",
        "id": 208,
        "price": 30,
        "type": "fruits"
    },
    {
        "name": "Snacks & Namkeen",
        "images": "https://www.jiomart.com/images/category/135/thumb/0-135.png",
        "quantity": "One Container",
        "id": 209,
        "price": 200,
        "type": "fruits"
    },
    {
        "name": "Chocolates & Candies",
        "images": "https://www.jiomart.com/images/category/43/thumb/0-43.png",
        "quantity": "One Unit",
        "id": 312,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Tea",
        "images": "https://www.jiomart.com/images/category/21/thumb/0-21.png",
        "quantity": "One Unit",
        "id": 314,
        "price": 10,
        "type": "fruits"
    },
    {
        "name": "Fruit juices",
        "images": "https://www.jiomart.com/images/category/25/thumb/0-25.png",
        "quantity": "One Unit",
        "id": 315,
        "price": 20,
        "type": "fruits"
    },
    {
        "name": "Energy & Soft Drinks",
        "images": "https://www.jiomart.com/images/category/26/thumb/0-26.png",
        "quantity": "One Unit",
        "id": 317,
        "price": 50,
        "type": "fruits"
    }

]
export default realData
